import { ToursSearch } from 'package-types';
import { Required } from 'package-utils';

import { generateRequestState } from '@helpers/endpoint.helper';

import { SearchParams } from '@interfaces/modules/tours/search';
import { defaultToursSearchSort, ToursSearchSort } from '@interfaces/services/api/tours-search.endpoint';

export class SearchResultState {
  @Required actualSearch!: { search: SearchParams, searchId: string | undefined };
  hotels: ToursSearch.HotelProposal[] = [];
  sort: ToursSearchSort = defaultToursSearchSort;
  isSorting = false;
  page = 0;
  hasNext = true;
  status?: ToursSearch.ResultStatus;
  departureCitiesMessage?: 'NoDepartureCities' | 'DepartureCitiesLoadingFailure' | 'DepartureCityRequired';
  requests = {
    search: generateRequestState()
  };
}
